(ns entities.expenses.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::input-value (s/nilable number?))

(s/def ::entertainment (s/nilable number?))
(s/def ::mortgage (s/nilable number?))
(s/def ::recurring-expenses (s/nilable number?))
(s/def ::recurring-payments (s/nilable number?))
(s/def ::tuition (s/nilable number?))

(s/def ::expenses (s/nilable (s/keys :req-un [::entertainment
                                              ::mortgage
                                              ::recurring-expenses
                                              ::recurring-payments
                                              ::tuition])))

(s/def :patch/entertainment ::input-value)
(s/def :patch/mortgage ::input-value)
(s/def :patch/recurring-expenses ::input-value)
(s/def :patch/recurring-payments ::input-value)
(s/def :patch/tuition ::input-value)

(s/def ::patch (s/keys :opt-un [:patch/entertainment
                                :patch/mortgage
                                :patch/recurring-expenses
                                :patch/recurring-payments
                                :patch/tuition]))
